import { useApp } from "../context/AppContext";
import { tr } from "../i18n/translations";

export default function Storytelling() {
  const { lang } = useApp();
  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 grid lg:grid-cols-2 gap-12 items-center" data-testid="storytelling">
      <div>
        <p className="text-xs uppercase tracking-[0.25em] text-ink/60 mb-4">Notre engagement</p>
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-light tracking-tight leading-tight">
          {tr(lang, "story_title").split(" ")[0]} <span className="italic text-pedablue">{tr(lang, "story_title").split(" ").slice(1).join(" ")}</span>
        </h2>
        <p className="mt-6 text-ink-soft text-lg leading-relaxed">{tr(lang, "story_body")}</p>
        <div className="mt-8 grid grid-cols-2 gap-6 max-w-md">
          <div>
            <p className="font-display text-3xl">+30%</p>
            <p className="text-xs text-ink-soft uppercase tracking-widest mt-1">moins cher que la concurrence</p>
          </div>
          <div>
            <p className="font-display text-3xl">100%</p>
            <p className="text-xs text-ink-soft uppercase tracking-widest mt-1">sélection clinicienne</p>
          </div>
        </div>
      </div>
      <div className="relative aspect-[4/5] rounded-3xl overflow-hidden">
        <img src="https://images.unsplash.com/photo-1758685733907-42e9651721f5?w=900&q=80" alt="enseignant et élève" loading="lazy" decoding="async" className="w-full h-full object-cover" />
        <div className="absolute bottom-6 start-6 end-6 bg-ivory/90 backdrop-blur-md rounded-2xl p-5">
          <p className="font-display italic text-lg leading-tight">« Une boutique enfin pensée pour notre métier. »</p>
          <p className="text-xs text-ink-soft mt-2">Camille B. · Orthopédagogue, Bruxelles</p>
        </div>
      </div>
    </section>
  );
}
